<div class="title mar-b10">{{data.title}}</div>
<div>
    <p class="rbt">{{data.body}}</p>
</div>
<div class="flex-row-end ">
    <button mat-stroked-button color="primary" [mat-dialog-close]="true">{{data.btn_ok}}</button>
</div>